import { v4 as uuid } from 'uuid'
import { fabric } from 'fabric'

const getData = (canvas: fabric.Canvas, template_id: number | string) => {
    return {
        originX: 'center',
        originY: 'center',
        left: canvas.getWidth() / 2,
        top: canvas.getWidth() / 2,
        width: canvas.getWidth() / 4,
        height: canvas.getWidth() / 4,
        angle: 0,
        opacity: 0.3,
        fill: '#FC0',
        borderColor: '#FC0',
        cornerColor: '#FC0',
        cornerStyle: 'circle' as 'circle' | 'rect' | undefined,
        cornerSize: 12,
        transparentCorners: false,
        centeredScaling: true,
        selectable: true,
        data: {
            id: uuid(),
            sync_id: null,
            type: null,
            name: 'Element',
            max_text_fields: 10,
            max_image_fields: 10,
            max_character: 1000,
            template_id: template_id,
            surcharge_kArtikel: null,
            individual_font_size: true,
            individual_text_color: true,
            individual_font_family: true,
            font_size: 40,
            font_color: '#000',
            font_families: '',
            fixed_user_inputs: false,
        },
    }
}

export const getCircle = (
    canvas: fabric.Canvas,
    template_id: number | string
) => {
    const data = {
        ...getData(canvas, template_id),
        radius: canvas.getWidth() / 8,
        perPixelTargetFind: true,
    }

    return new fabric.Circle(data)
}

export const getEllipse = (
    canvas: fabric.Canvas,
    template_id: number | string
) => {
    const data = {
        ...getData(canvas, template_id),
        rx: canvas.getWidth() / 8,
        ry: canvas.getWidth() / 8,
    }

    return new fabric.Ellipse(data)
}

export const getRectangle = (
    canvas: fabric.Canvas,
    template_id: number | string
) => {
    const data = {
        ...getData(canvas, template_id),
    }

    return new fabric.Rect(data)
}

export const getPolygon = (
    canvas: fabric.Canvas,
    template_id: number | string,
    id: string
) => {
    const cx = canvas.getWidth() / 2
    const cy = canvas.getWidth() / 2

    const points = [
        { x: cx, y: cy - cy / 2 },
        { x: cx + cx / 2, y: cy + cy / 2 },
        { x: cx - cx / 2, y: cy + cy / 2 },
    ]

    const { top, left, width, height, ...rest } = {
        ...getData(canvas, template_id),
    }
    const options = {
        ...rest,
        width: canvas.getWidth(),
        height: canvas.getHeight(),
        perPixelTargetFind: true,
        hasRotatingPoint: false,
        data: {
            id: id,
            sync_id: null,
            type: null,
            name: 'Element',
            max_text_fields: 10,
            max_image_fields: 10,
            max_character: 1000,
            template_id: template_id,
            surcharge_kArtikel: null,
            individual_font_size: true,
            individual_text_color: true,
            individual_font_family: true,
        },
    }

    return new fabric.Polygon(points, options)
}

export const getPolygonEdges = (polygon: fabric.Polygon) => {
    const edges: fabric.Circle[] = []

    if (!polygon.points) return edges

    polygon.points.forEach((point, index) => {
        const edge = new fabric.Circle({
            originX: 'center',
            originY: 'center',
            left: point.x,
            top: point.y,
            radius: 6,
            angle: 0,
            fill: '#FC0',
            centeredScaling: true,
            selectable: true,
            transparentCorners: true,
            hasBorders: false,
            hasControls: false,
            hasRotatingPoint: false,
            data: {
                id: uuid(),
                type: 'Edge',
                index: index,
                template_id: polygon.data.template_id,
                polygon_id: polygon.data.id,
                size: polygon.data.size,
            },
            opacity: 1,
        })

        edges.push(edge)
    })

    return edges
}
